/* eslint-disable
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let NotificationFilterState;
const { TrelloStorage } = require('@trello/storage');
const LocalStorageModel = require('app/scripts/view-models/internal/local-storage-model');

// We used to persist the Filter state in Local Storage manually, unscoped,
// If there's no existing state, use this one.
const getOldValue = () => TrelloStorage.get('visibilityFilter');
const deleteOldValue = () => TrelloStorage.unset('visibilityFilter');

module.exports = NotificationFilterState = (function () {
  NotificationFilterState = class NotificationFilterState extends LocalStorageModel {
    static initClass() {
      this.prototype.VISIBILITY_ALL = 'VISIBILITY_ALL';
      this.prototype.VISIBILITY_UNREAD = 'VISIBILITY_UNREAD';
    }

    constructor(idMember) {
      super(...arguments);
      this.set({ id: `notificationFilterState-${idMember}` });
      this.fetch();
      this.enableTabSync();
      if (this.getVisibility() === null) {
        this.setVisibility(getOldValue() || this.VISIBILITY_UNREAD);
        deleteOldValue();
      }
    }

    default() {
      return { visibilityFilter: null };
    }

    getVisibility() {
      return this.get('visibilityFilter');
    }

    setVisibility(visibility) {
      return this.update('visibilityFilter', visibility);
    }

    toggleVisibility() {
      const currentVisibility = this.getVisibility();
      const newVisibility =
        currentVisibility === this.VISIBILITY_ALL
          ? this.VISIBILITY_UNREAD
          : this.VISIBILITY_ALL;
      this.setVisibility(newVisibility);
      return newVisibility;
    }
  };
  NotificationFilterState.initClass();
  return NotificationFilterState;
})();
